import { render, staticRenderFns } from "./Nouveau.vue?vue&type=template&id=03240d29"
import script from "./Nouveau.vue?vue&type=script&lang=js"
export * from "./Nouveau.vue?vue&type=script&lang=js"
import style0 from "./Nouveau.vue?vue&type=style&index=0&id=03240d29&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports